import FinanceAdapter from './base';

export default class DepositSlip extends FinanceAdapter {
  modelNamePlural = 'depositSlips';
}
